// extracted by mini-css-extract-plugin
export default {"gpsIcon":"styles_gpsIcon__zF304","spinner":"styles_spinner__4Oydk"};